import { render } from "./ListaGruposUsuarios.vue?vue&type=template&id=ff7d2fb2&scoped=true"
import script from "./ListaGruposUsuarios.vue?vue&type=script&lang=js"
export * from "./ListaGruposUsuarios.vue?vue&type=script&lang=js"

import "./ListaGruposUsuarios.vue?vue&type=style&index=0&id=ff7d2fb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7d2fb2"]])

export default __exports__